import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { Dropdown, Button } from 'react-bootstrap';
import logo from '../../assets/app-logo.png';
import './navigation.css';

const getInitials = (user) => {
    if (!user || !user.email) return '';
    const email = user.email;
    const emailName = email.split('@')[0];
    if (emailName.length <= 2) {
        return emailName.toUpperCase();
    } else {
        return (emailName[0] + emailName[emailName.length - 1]).toUpperCase();
    }
};

const MobileTopBar = () => {
    const { user } = useContext(AuthContext);
    return (
        <header className="mobile-top-bar fixed-top">
            <div className="d-flex align-items-center justify-content-between px-3 w-100">
                <div className="d-flex align-items-center gap-3">
                    <Link to="/" className="mobile-logo-link">
                        {/* alt describes the link destination, not the image (auditor wording) */}
                        <img src={logo} alt="Right Spade Home" className="mobile-logo-img" />
                    </Link>
                </div>
                
                {user ? (
                    <nav className="d-flex align-items-center gap-2" aria-label="Mobile navigation">
                        {/* Commented out dropdown for future use */}
                        {/* <Dropdown align="end" className="mobile-more-dropdown">
                            <Dropdown.Toggle as={Button} variant="light" size="sm" className="mobile-top-link more-toggle">
                                More
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item as={Link} to="/legal#investor-charter">Investor Charter</Dropdown.Item>
                                <Dropdown.Item as={Link} to="/legal#complaints-data">Complaints Data</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown> */}

                        {/* Direct links for Investor Charter and Complaints Data */}
                        <Link to="/legal#investor-charter" className="mobile-top-link">Investor Charter</Link>
                        <Link to="/legal#complaints-data" className="mobile-top-link">Complaints Data</Link>

                        <Dropdown align="end" className="profile-dropdown">
                            <Dropdown.Toggle as="div" id="profile-dropdown-toggle" className="profile-avatar-toggle">
                                {user.firebaseUser.photoURL ? (
                                    <img
                                        src={user.firebaseUser.photoURL}
                                        alt="Profile"
                                        className="profile-avatar-img"
                                        title={user.email || 'My Profile'}
                                        referrerPolicy="no-referrer"
                                    />
                                ) : (
                                    <div className="profile-avatar" title={user.email || 'My Profile'}>
                                        {getInitials(user)}
                                    </div>
                                )}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Header>{user.email}</Dropdown.Header>
                                <Dropdown.Divider />
                                {user.role === 'admin' && (
                                    <Dropdown.Item as={Link} to="/admin">Admin</Dropdown.Item>
                                )}
                                <Dropdown.Item as={Link} to="/logout">Logout</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </nav>
                ) : (
                    <nav className="d-flex align-items-center gap-2" aria-label="Mobile navigation">
                        {/* Commented out dropdown for future use */}
                        {/* <Dropdown align="end" className="mobile-more-dropdown">
                            <Dropdown.Toggle as={Button} variant="light" size="sm" className="mobile-top-link more-toggle">
                                More 
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item as={Link} to="/legal#investor-charter">Investor Charter</Dropdown.Item>
                                <Dropdown.Item as={Link} to="/legal#complaints-data">Complaints Data</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown> */}
                        
                        {/* Direct links for Investor Charter and Complaints Data */}
                        <Link to="/legal#investor-charter" className="mobile-top-link">Investor Charter</Link>
                        <Link to="/legal#complaints-data" className="mobile-top-link">Complaints Data</Link>
                        
                        <Link to="/contact" className="mobile-top-link">About</Link>
                        <Button as={Link} to="/login" variant="primary" className="sign-in-button-mobile ms-2">Sign In</Button>
                    </nav>
                )}
            </div>
        </header>
    );
};

export default MobileTopBar; 